import React, {ReactElement} from "react";

import {sessionStorageEnabled} from "/src/utils/path-logging";
import {ConditionalFormType} from "/src/types";

import SimpleForm from "../../simple-form/SimpleForm";

export const SESSION_STORAGE_NAME = "FlexportHISInsuranceCoverageFormData";

const InsuranceForm = (props: ConditionalFormType): ReactElement => {
  const {conditionFields, childFields, ...simpleFormProps} = props;

  const [coverageSelection, setCoverageSelection] = React.useState<string>("");

  const updateConditionState = (fieldName: string, val: string) => {
    // eslint-disable-next-line default-case
    switch (fieldName) {
      case "insurance_coverage_selection":
        setCoverageSelection(val);

        // we are going to set the selected value in the storage
        // as well. this is to pass along the selected value to the next step
        if (sessionStorageEnabled()) {
          window.sessionStorage.setItem(SESSION_STORAGE_NAME, val);
        }
        break;
    }
  };

  const isInvisible = (fieldName: string) => {
    if (childFields.includes(fieldName)) {
      const conditions = conditionFields[fieldName];
      const conditionFieldNames = Object.keys(conditions);

      let result = true;
      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < conditionFieldNames.length; i++) {
        switch (conditionFieldNames[i]) {
          case "insurance_coverage_selection":
            result =
              !conditions[conditionFieldNames[i]].includes(coverageSelection);
            break;
          default:
            break;
        }
      }
      return result;
    }
    return false;
  };

  return (
    <SimpleForm
      {...simpleFormProps}
      updateConditionState={updateConditionState}
      isInvisible={isInvisible}
    />
  );
};

export default InsuranceForm;
